import React from 'react';
import { LegalDocPage } from './LegalDocPage';

export const CookiesPage: React.FC = () => {
  return (
    <LegalDocPage
      docId="cookies"
      title="Politique cookies"
      updatedAt="—"
    />
  );
};
